import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../CustomButton/CustomButton.jsx";

export default function AcknowledgmentModal({
  title,
  children,
  checkboxLabel,
  confirmBtnText = "I Agree",
  onConfirm,
}) {
  const [acknowledged, setAcknowledged] = useState(false);
  const requireAcknowledgment = Boolean(checkboxLabel);
  const confirmDisabled = requireAcknowledgment && !acknowledged;

  return (
    <Modal show backdrop="static" keyboard={false} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title
          style={{
            color: "red",
            textAlign: "center",
            width: "100%",
            fontWeight: "bold",
          }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{ color: "#333", lineHeight: "1.6" }}>{children}</div>

        {requireAcknowledgment && (
          <div style={{ marginTop: "1.5rem" }}>
            <label style={{ cursor: "pointer", fontWeight: "normal" }}>
              <input
                type="checkbox"
                checked={acknowledged}
                onChange={(e) => setAcknowledged(e.target.checked)}
                style={{ marginRight: "0.5rem" }}
              />
              {checkboxLabel}
            </label>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          bsStyle="primary"
          fill
          block
          disabled={confirmDisabled}
          onClick={onConfirm}
        >
          {confirmBtnText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
